import { render, staticRenderFns } from "./ValidationDenied.vue?vue&type=template&id=58c2a5b0&scoped=true"
import script from "./ValidationDenied.vue?vue&type=script&lang=js"
export * from "./ValidationDenied.vue?vue&type=script&lang=js"
import style0 from "./ValidationDenied.vue?vue&type=style&index=0&id=58c2a5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c2a5b0",
  null
  
)

export default component.exports